import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { campaignSettingList } from 'lib/api/adverlive';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import Modal from 'components/organisms/NewModal';
import NewTableContainer from 'components/molecules/NewTable';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import MultiSelect from 'components/organisms/MultiSelect';
import FilterCollection from 'components/organisms/FilterCollection';

const CampaignSettingList = () => {
  const { t } = useTranslation();
  let initParams = {
    sort: 'asc',
    order: 'POINT',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().add(-1, 'day').format('YYYYMMDD'),
    advrtsPrdtCode: '01',
    advrtsTpCode: '05',
    point: '1000',
    exAdverIds: 'test,adday',
    exContactName:
      'test,테스트,망고,망고스타일,스타일썸,옷잘남,면세점모아,핵딜',
    exCorpName: 'test,테스트,망고,망고스타일,스타일썸,옷잘남,면세점모아,핵딜',
    exMallIds: 'dutyfreemoa,hackdeal,otjalnam,stylessum',
    cmapState: '01',
    campPltfomTpCode: 'all',
    mobileBaconFlag: 'all',
    cpAdUseYn: 'all',
    bannerType: 'all',
  };
  const initModal = { open: false, params: initParams, headerOpen: false };
  const [modal, setModal] = useState(initModal);
  const [tempParams, setTempParams] = useState(initParams);
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  const list = {
    solution: [
      { name: '메이크샵 D2', description: '', value: 'makeshop_d2' },
      { name: '메이크샵 D4', value: 'makeshop_d4' },
      { name: '카페24', value: 'cafe24' },
      { name: '카페24 스마트', value: 'cafe24_smart' },
      { name: '고도몰 임대형', value: 'godo' },
      { name: '고도몰 독립형', value: 'godo_self' },
      { name: '독립몰', value: 'self' },
      { name: '퍼스트몰', value: 'first' },
      { name: '후이즈몰', value: 'whoismall' },
      { name: '위사몰', value: 'wisa' },
      { name: '스타일썸', value: 'stylessum' },
      { name: '옷잘남', value: 'otjalnam' },
      { name: '핵딜', value: 'hackdeal' },
      { name: '면세점모아', value: 'dutyfreemoa' },
      { name: '기타', value: 'etc' },
    ],
    campPltfomTpCode: [
      { label: '전체', value: 'all' },
      { label: '웹', value: '01' },
      { label: '모바일', value: '02' },
    ],
    cmapState: [
      { label: '전체', value: 'all' },
      { label: '게재중', value: '01' },
      { label: '중지', value: '02' },
    ],
    mobileBaconFlag: [
      { label: '전체', value: 'all' },
      { label: '사용', value: '01' },
      { label: '미사용', value: '02' },
    ],
    cpAdUseYn: [
      { label: '전체', value: 'all' },
      { label: '사용', value: '01' },
      { label: '미사용', value: '02' },
    ],
    bannerType: [
      { label: '전체', value: 'all' },
      { label: '상품화배너', value: '01' },
      { label: '고정배너', value: '02' },
    ],
  };

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const customized = {
    PAR_CNT: {
      makeHead: () => {
        return t('지면수');
      },
      makeBody: (rowObj, headsMap) => {
        const rowData1 = getHeadObj(headsMap, 'PAR_CNT');
        if (rowObj['ADVER_ID'].indexOf('/') !== -1) {
          return '';
        } else {
          return makeRowColumn(
            rowObj['PAR_CNT'],
            rowData1.type,
            rowData1.format
          );
        }
      },
      orderFlag: false,
    },
    POINT: {
      makeHead: () => {
        return t('잔여금액');
      },
      makeBody: (rowObj, headsMap) => {
        const rowData1 = getHeadObj(headsMap, 'POINT');
        return makeRowColumn(rowObj['POINT'], rowData1.type, '#,###');
      },
      orderFlag: false,
    },
    BANNER_TYPE_STR: {
      makeHead: () => {
        return (
          <>
            {t('배너타입')}
            <br />
            {t('상품/고정')}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const rowData1 = getHeadObj(headsMap, 'BANNER_TYPE_STR');
        return makeRowColumn(
          rowObj['BANNER_TYPE_STR'],
          rowData1.type,
          rowData1.format
        );
      },
    },
    ADVER_ID: {
      makeHead: () => {
        return t('광고주아이디');
      },
      makeBody: (rowObj) => {
        let contents;
        if (rowObj['ADVER_ID'].indexOf('광고주') !== -1) {
          let tmpData = rowObj['ADVER_ID'].split('/');
          contents = (
            <>
              {tmpData[0]}
              <br />
              {tmpData[1]}
            </>
          );
        } else {
          contents = rowObj['ADVER_ID'];
        }
        return contents;
      },
    },
  };

  const handleOnReset = () => {
    if (
      JSON.stringify(params) !== JSON.stringify(initParams) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParams)
    ) {
      setInitialization(true);
      setParams(initParams);
      setTempParams(initParams);
    }
  };

  const getTempParam = (newParams) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  const getParam = () => {
    if (JSON.stringify(params) !== JSON.stringify(tempParams)) {
      setParams(tempParams);
    }
  };

  /**
   * modal 열어주는 함수
   */
  const handleModalOpen = () => {
    let newModal = { ...initModal };
    newModal = { ...newModal, open: true, params: { ...tempParams } };
    setModal({ ...newModal });
  };

  /**
   * 모달 닫아주는 함수
   */
  const handleClose = () => {
    let newModal = { ...modal };
    newModal = { ...newModal, open: false };
    setModal(newModal);
  };

  /**
   * 모달에 submit 버튼을 눌렀을 때 실행되는 함수
   */
  const handleSubmit = () => {
    setTempParams(modal.params);
    setModal({ ...initModal, open: false, params: modal.params });
  };

  const modalGetParams = (newParams, type) => {
    let newModal = { ...modal, params: newParams };
    if (newModal['params'][type] === '') delete newModal['params'][type];
    if (JSON.stringify(modal.params) !== JSON.stringify(newModal.params)) {
      setModal(newModal);
    }
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getTempParam}
          params={tempParams}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
          required={{
            type: 'DisplayFilter',
            val: ['advrtsPrdtCode', 'advrtsTpCode'],
          }}
        />
        <NewButton
          type="filterButton"
          name="category"
          onClick={handleModalOpen}
        >
          {t('조건선택')}
        </NewButton>
        <NewButton type="filterButton" name="submit" onClick={getParam}>
          {t('검색')}
        </NewButton>
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        dataReqPromise={campaignSettingList}
        getParam={(newParams) => setParams(newParams)}
        customized={customized}
        useSearch={false}
      />
      <Modal
        open={modal.open}
        headerOpen={modal.headerOpen}
        handleClose={handleClose}
        confirmOnClick={handleSubmit}
        useForm
      >
        <tr>
          <th>{t('잔액')}</th>
          <td>
            <NewInput
              type="tableInput"
              name="point"
              params={modal.params}
              value={modal.params.point}
              callBack={modalGetParams}
            />
          </td>
        </tr>
        <tr>
          <th>{t('광고주ID 제외')} </th>
          <td>
            <NewInput
              type="tableInput"
              name="exAdverIds"
              params={modal.params}
              value={modal.params.exAdverIds}
              callBack={modalGetParams}
            />
          </td>
        </tr>
        <tr>
          <th>{t('담당자명 제외')} </th>
          <td>
            <NewInput
              type="tableInput"
              name="exContactName"
              params={modal.params}
              value={modal.params.exContactName}
              callBack={modalGetParams}
            />
          </td>
        </tr>
        <tr>
          <th>{t('회사명 제외')} </th>
          <td>
            <NewInput
              type="tableInput"
              name="exCorpName"
              params={modal.params}
              value={modal.params.exCorpName}
              callBack={modalGetParams}
            />
          </td>
        </tr>
        <tr>
          <th>{t('솔루션 제외')} </th>
          <td>
            <MultiSelect
              list={list.solution}
              // dataReqPromise={noBannerPayType}
              params={modal.params}
              callBack={modalGetParams}
              title={t('솔루션제외')}
              name="exMallIds"
            />
          </td>
        </tr>
        <tr>
          <th>{t('웹모바일 구분')} </th>
          <td>
            <FilterCollection
              label={t('웹모바일 구분')}
              name="campPltfomTpCode"
              params={modal.params}
              value={modal.params.campPltfomTpCode}
              type="radio"
              list={list.campPltfomTpCode}
              callBack={modalGetParams}
              labelKey="label"
              valueKey="value"
            />
          </td>
        </tr>

        <tr>
          <th>{t('캠페인 노출기준')} </th>
          <td>
            <FilterCollection
              label={t('캠페인 노출기준')}
              name="cmapState"
              params={modal.params}
              value={modal.params.cmapState}
              type="radio"
              list={list.cmapState}
              callBack={modalGetParams}
              labelKey="label"
              valueKey="value"
            />
          </td>
        </tr>
        <tr>
          <th>{t('모바일 바콘사용')}</th>
          <td>
            <FilterCollection
              label={t('모바일바콘설정')}
              name="mobileBaconFlag"
              params={modal.params}
              value={modal.params.mobileBaconFlag}
              type="radio"
              list={list.mobileBaconFlag}
              callBack={modalGetParams}
              labelKey="label"
              valueKey="value"
            />
          </td>
        </tr>
        <tr>
          <th>{t('커플광고 사용여부')}</th>
          <td>
            <FilterCollection
              label={t('커플광고설정')}
              name="cpAdUseYn"
              params={modal.params}
              value={modal.params.cpAdUseYn}
              type="radio"
              list={list.cpAdUseYn}
              callBack={modalGetParams}
              labelKey="label"
              valueKey="value"
            />
          </td>
        </tr>
        <tr>
          <th>{t('배너형태')}</th>
          <td>
            <FilterCollection
              label={t('배너형태')}
              name="bannerType"
              params={modal.params}
              value={modal.params.bannerType}
              type="radio"
              list={list.bannerType}
              callBack={modalGetParams}
              labelKey="label"
              valueKey="value"
            />
          </td>
        </tr>
        <tr>
          <th>{t('스크립트No')} </th>
          <td>
            <NewInput
              type="tableInput"
              name="mediaScriptNo"
              params={modal.params}
              value={modal.params.mediaScriptNo}
              callBack={modalGetParams}
            />
          </td>
        </tr>
        <tr>
          <th>{t('광고주ID')} </th>
          <td>
            <NewInput
              type="tableInput"
              name="adverId"
              params={modal.params}
              value={modal.params.adverId}
              callBack={modalGetParams}
            />
          </td>
        </tr>
      </Modal>
    </>
  );
};

export default React.memo(CampaignSettingList);
